import { Dispatch, FC, SetStateAction, useEffect } from "react";
import Logo from "../common/loading/logo/Logo";
import { ILoginState } from "../../pages/SignIn.page";
import { useHandleField } from "../../hooks/useHandleField";
import Input from "../form/Input";
import Button from "../form/Button";
import useClickByKey from "../../hooks/useClickByKey";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { getCurrentUser } from "../../store/authSlice";
import { useNavigate } from "react-router-dom";

const SignInForm: FC<{ 
  state: ILoginState,
  stateErr?: Partial<Record<keyof ILoginState, string>>,
  setState: Dispatch<SetStateAction<ILoginState>>,
  loading?: boolean,
  onSignIn: () => unknown,
}> = ({
  state,
  stateErr,
  setState,
  loading,
  onSignIn,
}) => {
  const navigate = useNavigate();
  const currentUser = useTypedSelector(getCurrentUser());
  const handleField = useHandleField(setState); 
  const { btnRef, onKeyUp } = useClickByKey();
  
  useEffect(() => {
    currentUser && navigate('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser])

  return (
    <>
      <div className="sm:mx-auto sm:w-full sm:max-w-md flex justify-center">
        <Logo size="large" />
      </div>
      <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-[400px]">
        <div className="bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12">
          <form className="space-y-6">        
            <Input
              label="Username"
              name="login"
              size="large"
              type="text"
              value={state.login}
              handle={handleField('login')}
              disabled={loading}
              error={stateErr?.login}
              onKeyUp={onKeyUp}
            />
            <Input
              label="Password"
              name="password"
              size="large"
              type="password"
              value={state.password}
              handle={handleField('password')}
              error={stateErr?.password}
              disabled={loading}
              onKeyUp={onKeyUp}
            />
            <div>
              <Button
                btnRef={btnRef}
                size="large"
                onClick={onSignIn}
                disabled={loading}
              >
                SIGN IN
              </Button>              
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SignInForm;